module.exports = __webpack_public_path__ + "static/media/icon-engine.4cf898ee.svg";